import React, { useContext } from 'react'
import gql from 'graphql-tag'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { IOverviewFilter } from './ResourceActivityOverviewTable'
import { AnalyticsContext } from '../AnalyticsContext'
import { prepareCSVResourceActivityExport } from './csv-resource-activity'

export interface IResourceActivityCsvResponse {
  viewsCount: number
  displayName: string
  userId: number
  lastViewedAt: string
}

const csvQuery = gql`
  query (
    $mainAnalyticsFilter: AnalyticsFilterWithGroups!
    $overviewFilter: AnalyticsResourceActivityFilter!
  ) {
    analytics(filter: $mainAnalyticsFilter) {
      resources {
        resourceActivityOverview(overviewFilter: $overviewFilter) {
          displayName
          userId
          lastViewedAt
          viewsCount
        }
      }
    }
  }
`

interface IDownloadResourceActivityCSVProps {
  overviewFilter: IOverviewFilter
  resourceActivityCount: number
}

export const DownloadResourceActivityCSV = ({
  overviewFilter,
  resourceActivityCount
}: IDownloadResourceActivityCSVProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)

  return (
    <DownloadCSVButton
      count={resourceActivityCount}
      fileName={'looop-resource-activity'}
      dataPath={'data.analytics.resources.resourceActivityOverview'}
      queryOptions={(page, limit) => ({
        variables: {
          mainAnalyticsFilter: filterAsQueryVariables,
          overviewFilter: {
            ...overviewFilter,
            page,
            limit
          }
        },
        query: csvQuery,
        fetchPolicy: 'no-cache'
      })}
      prepareData={prepareCSVResourceActivityExport}
    />
  )
}
